// Module-level set that tracks which conversation IDs are currently being
// actively watched by a mounted PatientInbox instance.
// PatientCallListener reads this to avoid double-handling the same call.
const watchedConvIds = new Set<string>();

export const registerWatchedConv = (id: string) => watchedConvIds.add(id);
export const unregisterWatchedConv = (id: string) => watchedConvIds.delete(id);
export const isConvWatched = (id: string) => watchedConvIds.has(id);
